import {
  fetchAllowedCountries,
  fetchApiCreds,
  fetchCompanyConsumption,
  fetchJobs,
  fetchServicesInfo,
  fetchUser,
  fetchWebhooks,
} from '../api'
import { SORT_DESCENDING } from '../components/TaskList/JobListDef'

import {
  resetLayoutSlice,
  resetUserSlice,
  setJobsSortDirection,
  store,
} from '../store'

export const signInUser = async () => {
  await fetchUser()
  fetchCompanyConsumption()
  store.dispatch(setJobsSortDirection(SORT_DESCENDING))
  fetchJobs({ refreshing: true })
  fetchServicesInfo()
  fetchApiCreds()
  fetchWebhooks()
  fetchAllowedCountries()
}

export const signOutUser = () => {
  store.dispatch(resetUserSlice())
  store.dispatch(resetLayoutSlice())
}


